import { nextTick, ref } from 'vue'
import { companyApi } from '@/services/api'

/**
 * @deprecated use useInfinityCompany instead
 */
export const useInfiniteCompany = ({ values = ref([]), limit = ref(30), page = ref(0) }) => {
  // <b-autocomplete-infity class="w-full" @get-more-data="getMoreResources" :list="resourceAutoComplete.list"
  // :selected="project.contributors" @add-selected="addSalesContributor"
  // @remove-selected="removeSalesContributor"
  // :haveMore="resourceAutoComplete.haveMore && !resourceAutoComplete.loading">
  // <template #custom-list="{ selectItem, list }">
  const list = ref([])
  const haveMore = ref(true)
  const loading = ref(false)
  const select = (selected) => {
    // Si values.value est un objet
    if (!Array.isArray(values.value)) {
      values.value = selected

      return
    }

    // Si values.value est un tableau
    const officeIndex = values.value.findIndex(office => office._id === selected._id)
    if (officeIndex > -1)
      return values.value.splice(officeIndex, 1)

    values.value.push(selected)
  }
  const getMoreData = async (options) => {
    if (options.new) {
      page.value = 0
      haveMore.value = true
    }
    loading.value = true
    const companyRequest = await companyApi.filter({ page: page.value, limit: limit.value, search: options.search }).promise
    loading.value = false
    list.value = options.new ? companyRequest.docs : [...list.value, ...companyRequest.docs]
    haveMore.value = companyRequest.count?.currentPage < companyRequest.count?.totalPages
    page.value++
    return list
  }

  const remove = (toRemove) => {
    // Si values.value est un objet
    if (!Array.isArray(values.value))
      values.value = null

    // Si values.value est un tableau
    const foundIndex = values.value.findIndex(currentCompany => currentCompany._id === toRemove._id)
    if (foundIndex === -1)
      return

    values.value.splice(foundIndex, 1)
  }

  return {
    haveMore,
    getMoreData,
    remove,
    select,
    list,
    loading,
    values,
  }
}


export const useInfinityCompany = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]), isSupplier = ref(), isClient = ref() }) => {
  const haveMore = ref(true)
  const getMoreData = async () => {
    try {
      isLoading.value = true;

      const searchRequest = companyApi.filter({ search: search.value, limit: limit.value, page: page.value, isSupplier:isSupplier.value, isClient:isClient.value })
      const searchResponse = await searchRequest.promise
      haveMore.value = searchResponse.count.hasNextPage

      await nextTick() // to be sure have more is updated so the request won't be done again

      list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]

      return searchResponse
    }
    catch (err) {
      console.log('err', err)
    }
    finally {
      isLoading.value = false;
    }
  }
  
  return {
    search,
    limit,
    page,
    haveMore,
    getMoreData,
    list,
    isLoading,
  }
}
